const STORAGE_KEY = 'm24.upsell.autoModal';

let openedInThisPage = false;

/**
 * True when an automatic upsell modal (the first-file reveal or the takeover) opened in this
 * session already: at most one opens in one session (trial upsell spec 2026-10-13 §4). The tab
 * keeps the mark across a reload (`sessionStorage`); a browser that blocks the storage keeps it for
 * the page only.
 */
export function hadAutoModalThisSession(): boolean {
  if (openedInThisPage) {
    return true;
  }
  try {
    return window.sessionStorage.getItem(STORAGE_KEY) === '1';
  } catch (error) {
    console.error(error);
    return false;
  }
}

export function markAutoModalThisSession(): void {
  openedInThisPage = true;
  try {
    window.sessionStorage.setItem(STORAGE_KEY, '1');
  } catch (error) {
    console.error(error);
  }
}

/** For tests: a new session. */
export function resetAutoModalSession(): void {
  openedInThisPage = false;
  try {
    window.sessionStorage.removeItem(STORAGE_KEY);
  } catch (error) {
    console.error(error);
  }
}
